<div class="reports main-div-with-gray-bkg">
  <!-- class="height-separater" -->
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb embeded-breadcrum-padding m-0 pt-3">
        <li class="breadcrumb-item"><a href="/landing-page">Home</a></li>
        <li class="breadcrumb-item" aria-current="page">
          <a href="/reports" style="padding-left: 4%;">Reports</a>
        </li>
        <li class="breadcrumb-item"></li>
        <li aria-current="page" style="color: #6c757d;">
          {{ ReportName }}
        </li>
      </ol>
    </nav>
  </div>
  <div class="row p-3">
    <div class="col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 p-0">
      <div class="card-table-gap p-0">
        <div class="col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 card-structure">
          <div class="report" id="reportContainer"></div>
        </div>
      </div>
    </div>
  </div>
</div>
